import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import isToday from 'dayjs/plugin/isToday'
import isYesterday from 'dayjs/plugin/isYesterday'
import 'dayjs/locale/en'
import 'dayjs/locale/es'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/ja'
import 'dayjs/locale/ko'
import 'dayjs/locale/uk'
import 'dayjs/locale/ru'
import 'dayjs/locale/ar'
import 'dayjs/locale/pt'
import 'dayjs/locale/fr'
import 'dayjs/locale/de'
import 'dayjs/locale/it'
import 'dayjs/locale/pl'
import 'dayjs/locale/tr'
import 'dayjs/locale/hu'

dayjs.extend(relativeTime)
dayjs.extend(isToday)
dayjs.extend(isYesterday)

type DayjsLocaleMap = Record<string, string>

export function setDayjsLocale(locale: string) {
  const map: DayjsLocaleMap = {
    en: 'en',
    'zh-CN': 'zh-cn',
    'zh-hk': 'zh-cn', // dayjs 没有 zh-hk，使用 zh-cn
    ja: 'ja',
    ko: 'ko',
    uk: 'uk',
    ru: 'ru',
    ar: 'ar',
    pt: 'pt',
    es: 'es',
    fr: 'fr',
    de: 'de',
    it: 'it',
    pl: 'pl',
    tr: 'tr',
    hu: 'hu',
  }
  dayjs.locale(map[locale] || 'en')
}
